<template>
    <div>
        <a-page-header style="border: 1px solid rgb(235, 237, 240)" :ghost="false" title="User Klasikal">
            <common-training-header/>
        </a-page-header>

        <a-card type="inner" size="small">
            <a-tabs>
                <a-tab-pane key="1" tab="Peserta">
                    <admin-setting-user-attendant />
                </a-tab-pane>
                <a-tab-pane key="2" tab="Tim Project" force-render>
                    <admin-setting-user-project />
                </a-tab-pane>
            </a-tabs>
        </a-card>
    </div>
</template>

<script>
export default {
    
}
</script>